import { http } from '@Techedge/digitalportal-shared'
import { b64toBlob } from '../utils/commonFunctions'

export class NotificationsApi {
	static BASE_URL: string = process.env.REACT_APP_BASE_URL_BE
	static NOTIFICATIONS_URL: string =
		NotificationsApi.BASE_URL + `/notificationsapi`

	static headersObj = {
		headers: {
			'Accept-Language': '',
		},
		timeout: 180000,
	}

    static getBrowsingToolNotifications = ():any => {
        return http.get<any>(
            NotificationsApi.NOTIFICATIONS_URL + `/notifications/toast`,
            NotificationsApi.headersObj
        )
    }
}

export class GalleryService {
	static BASE_URL: string = process.env.REACT_APP_BASE_URL_BE
	static ATTACHMENTS_URL: string = GalleryService.BASE_URL + `/attachmentsapi`

    static headersObj = {
        headers: {
            'Accept-Language': '',
        },
        timeout: 180000,
    }

    static uploadFile = (
        file: any,
        fileName: string,
        contentType: string
    ): Promise<any> => {
        const formData = new FormData()
        var splittedB64 = file.split(',')[1]
        var blob = b64toBlob(splittedB64, contentType)
        formData.append('file', blob, fileName)
        formData.append('type', 'photo')
        formData.append('attachmentType', 'projectattachment')
        return http.post<any>(`${GalleryService.ATTACHMENTS_URL}/project/upload`, formData, {
            ...GalleryService.headersObj,
            headers: {
                ...GalleryService.headersObj.headers,
                'Content-Type': 'multipart/form-data',
            },
        })
    }
}
